
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains",
      function () {
        return require("private-next-pages/trains.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains"])
      });
    }
  